import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { useAuth } from "../../components/context/AuthContext";
// getDepartmans ve createTicket API fonksiyonlarını kendi yapına göre çağırıyorsun
import { createTicket, getDepartmans } from "../../api/ticketApi";

function TalepEkrani() {
  const { user } = useAuth();

  // Departman listesi için state
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  // Form verileri (Backend'in beklediği key'ler ve default valuelar aynı kaldı)
  const [formData, setFormData] = useState({
    ticketType: "issue",
    priority: "high",
    department: "",
    station: "",
    relatedPersons: "", // Virgülle ayrılmış string alıp, gönderirken array yapacağız
    description: "",
    mediaUrl: "",
  });

  // Bileşen yüklendiğinde departmanları çek
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await getDepartmans(user.token);
        // Backend'den gelen cevaba göre burayı kendine uyarla (örn: response.data)
        setDepartments(response.data || []);
      } catch (error) {
        console.error("Departmanlar çekilirken hata:", error);
      }
    };

    if (user && user.token) {
      fetchDepartments();
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: "", type: "" });

    // İlgili kişileri virgüllerden ayırıp tertemiz bir Array'e dönüştürüyoruz
    const formattedPersons = formData.relatedPersons
      .split(",")
      .map((person) => person.trim())
      .filter((person) => person !== "");

    // API'ye gönderilecek nihai veri (Senin JSON formatı)
    const payload = {
      ...formData,
      relatedPersons: formattedPersons,
    };

    try {
      // Talep oluşturma isteği
      await createTicket(payload, user.token);
      setMessage({ text: "Talebiniz başarıyla oluşturuldu!", type: "success" });

      // Başarılı olunca formu ilk haline döndürelim
      setFormData({
        ticketType: "issue",
        priority: "high",
        department: "",
        station: "",
        relatedPersons: "",
        description: "",
        mediaUrl: "",
      });
    } catch (error) {
      console.error("Talep açılırken hata:", error);
      setMessage({
        text: "Talep oluşturulamadı. Lütfen tekrar deneyin.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  // Ortak input stilleri (Kodu temiz tutmak için)
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    marginBottom: "16px",
    borderRadius: "8px",
    border: "1px solid #ced4da",
    boxSizing: "border-box",
    fontSize: "14px",
    fontFamily: "inherit",
  };

  return (
    <Layout>
      <section
        style={{
          flex: 1,
          maxWidth: "700px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          padding: "32px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h2
            style={{
              fontWeight: 600,
              color: "#283049",
              marginBottom: "8px",
              fontSize: "28px",
            }}
          >
            Yeni Talep Oluştur
          </h2>
          <p style={{ color: "#6c757d", fontSize: "15px" }}>
            Hoş geldin, {user.name}. Karşılaştığın bir sorunu veya yeni bir
            talebini aşağıdaki formu doldurarak bildirebilirsin.
          </p>
        </div>

        {message.text && (
          <div
            style={{
              padding: "12px",
              marginBottom: "20px",
              borderRadius: "8px",
              backgroundColor:
                message.type === "success" ? "#d4edda" : "#f8d7da",
              color: message.type === "success" ? "#155724" : "#721c24",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            {message.text}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div style={{ display: "flex", gap: "16px" }}>
            <div style={{ flex: 1 }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  fontWeight: 500,
                  color: "#495057",
                  fontSize: "14px",
                }}
              >
                Talep Tipi
              </label>
              <select
                name="ticketType"
                value={formData.ticketType}
                onChange={handleChange}
                style={inputStyle}
              >
                {/* Backend değerleri (value) aynı kaldı, görünen yüz tamamen Türkçe */}
                <option value="issue">Sorun Bildirimi</option>
                <option value="suggestion">Öneri</option>
                <option value="request">Yeni Talep</option>
              </select>
            </div>

            <div style={{ flex: 1 }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  fontWeight: 500,
                  color: "#495057",
                  fontSize: "14px",
                }}
              >
                Öncelik Durumu
              </label>
              <select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="low">Düşük</option>
                <option value="medium">Orta</option>
                <option value="high">Yüksek</option>
                <option value="urgent">Acil</option>
              </select>
            </div>
          </div>

          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
              color: "#495057",
              fontSize: "14px",
            }}
          >
            İlgili Departman
          </label>
          <select
            name="department"
            value={formData.department}
            onChange={handleChange}
            style={inputStyle}
            required
          >
            <option value="" disabled>
              Lütfen Departman Seçiniz
            </option>
            {departments.map((dept) => (
              <option key={dept._id || dept.id} value={dept._id || dept.id}>
                {dept.name || dept.title}
              </option>
            ))}
          </select>

          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
              color: "#495057",
              fontSize: "14px",
            }}
          >
            İstasyon / Konum
          </label>
          <input
            type="text"
            name="station"
            placeholder="Örn: Paketleme Hattı"
            value={formData.station}
            onChange={handleChange}
            style={inputStyle}
            required
          />

          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
              color: "#495057",
              fontSize: "14px",
            }}
          >
            İlgili Kişiler (Birden fazlaysa virgülle ayırın)
          </label>
          <input
            type="text"
            name="relatedPersons"
            placeholder="Örn: Ahmet Usta, Mustafa Bey"
            value={formData.relatedPersons}
            onChange={handleChange}
            style={inputStyle}
          />

          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
              color: "#495057",
              fontSize: "14px",
            }}
          >
            Detaylı Açıklama
          </label>
          <textarea
            name="description"
            rows="4"
            placeholder="Sorunu veya talebinizi detaylı bir şekilde açıklayın..."
            value={formData.description}
            onChange={handleChange}
            style={{ ...inputStyle, resize: "vertical" }}
            required
          ></textarea>

          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
              color: "#495057",
              fontSize: "14px",
            }}
          >
            Ekstra Dosya / Medya Linki (İsteğe Bağlı)
          </label>
          <input
            type="text"
            name="mediaUrl"
            placeholder="https://..."
            value={formData.mediaUrl}
            onChange={handleChange}
            style={inputStyle}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: "16px",
              padding: "14px",
              backgroundColor: loading ? "#6c757d" : "#0056b3",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.2s",
            }}
          >
            {loading ? "Talep Gönderiliyor..." : "Talebi Gönder"}
          </button>
        </form>
      </section>
    </Layout>
  );
}

export default TalepEkrani;
